export default {"src":"/_next/static/media/bandaids_24.b3786628.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};